import React from 'react';
import { DateTimePickerV2, Flex, NumericInput } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import I18N from '@leverege/i18n';
import NumericEqualsComparator from "./NumericEqualsComparator.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  tf,
  tfIcon
} = I18N.ns('ui-attributes.condition.comparator.type.numeric.NumericEqualsComparatorEditor');
export default function NumericEqualsComparatorEditor(props) {
  const {
    value,
    attribute,
    variant,
    usage
  } = props;
  const value1 = NumericEqualsComparator.getValue1(value);
  const onModelChange = useValueChange(NumericEqualsComparator, props);
  const style = usage === 'table' ? {
    width: '100%'
  } : null;
  return /*#__PURE__*/_jsx(Flex, {
    style: style,
    variant: "rowM",
    align: "center",
    children: attribute.valueType === 'timestamp' ? /*#__PURE__*/_jsx(DateTimePickerV2, {
      style: style,
      wrapperStyle: style,
      variant: variant,
      value: value1,
      onChange: onModelChange,
      eventData: "setValue1"
    }) : /*#__PURE__*/_jsx(NumericInput, {
      style: style,
      variant: variant,
      float: attribute.valueType !== 'int',
      value: value1,
      onChange: onModelChange,
      eventData: "setValue1"
    })
  });
}
NumericEqualsComparatorEditor.isInline = true;
NumericEqualsComparatorEditor.getSelectedName = tf('selectedName');
NumericEqualsComparatorEditor.getIcon = tfIcon('icon');